<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     费用中心-账单管理-账单明细
  +---------------------------------------------------------------------------------------
-->
<template>
  <div class="expense-bill-statement mb-md">
    <div class="filter-container">
      <div class="filter-box">
        <div class="filter-item">
          <el-radio-group v-model="listQuery.direct" @change="fetchData(1)">
            <el-radio-button :label="-10">所有账单</el-radio-button>
            <el-radio-button :label="1">收入</el-radio-button>
            <el-radio-button :label="2">支出</el-radio-button>
          </el-radio-group>
        </div>
        <div class="filter-item" style="width: 160px">
          <el-date-picker
            v-model="listQuery.period"
            type="month"
            value-format="yyyy-MM"
            placeholder="账期"
            style="width: 160px"
            @change="fetchData(1)" />
        </div>
        <div class="filter-item" style="width: 200px">
          <el-input v-model="listQuery.keyword" placeholder="账单号 / 主题" prefix-icon="el-icon-search" clearable @change="fetchData(1)" />
        </div>
      </div>
    </div>

    <el-card v-if="list.length > 0" v-loading="loading" shadow="never">
      <el-table
        ref="listTable"
        :data="list"
        tooltip-effect="dark"
        class="padding-small">
        <el-table-column label="主题" width="80">
          <template slot-scope="scope">
            <el-tooltip
              placement="right-start">
              <span v-if="scope.row.type === 1" slot="content">增值收入</span>
              <span v-if="scope.row.type === 2" slot="content">订单消费</span>
              <span v-if="scope.row.type === 3" slot="content">账户充值</span>
              <span v-if="scope.row.type === 4" slot="content">账户提现</span>
              <f-image class="image large" :src="require('@/assets/bill-' + scope.row.type + '.png')" />
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="des" min-width="200" />
        <el-table-column min-width="140" label="创建时间">
          <template slot-scope="scope">
            <span>{{ scope.row.createtime | parseTime('{y}/{m}/{d} {h}:{i}') }}</span>
          </template>
        </el-table-column>
        <el-table-column label="金额" align="right" min-width="120">
          <template slot-scope="scope">
            <div v-if="scope.row.direct === 1" class="flow font-lg text-warning"><strong> + {{ scope.row.flow_amount | currency }}</strong></div>
            <div v-if="scope.row.direct === 2" class="flow font-lg"><strong> - {{ scope.row.flow_amount | currency }}</strong></div>
          </template>
        </el-table-column>
        <el-table-column label="" align="" width="60">
          <template slot-scope="scope">
            <el-popover
              v-if="scope.row.remark"
              placement="top-end"
              trigger="hover">
              <span>{{ scope.row.remark }}</span>
              <div slot="reference" class="text-muted font-2x">
                <i class="iconfont icon-circle-question"></i>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <template slot="append">
          <f-table-footer>
            <template slot="right">
              <f-pagination :total="total" :pindex.sync="listQuery.pindex" :psize.sync="listQuery.psize" @change="fetchData" />
            </template>
          </f-table-footer>
        </template>
      </el-table>
    </el-card>
    <el-card v-else v-loading="loading" shadow="never">
      <p class="text-center text-muted">暂无数据</p>
    </el-card>
  </div>
</template>

<script>
import { billFlowApi } from '@/api/expense/expenseBillApi'
export default {
  name: 'ExpenseBillStatement',
  components: {
  },
  data() {
    return {
      loading: false,
      listQuery: {
        direct: this.$route.query.direct ? this.$route.query.direct : -10,
        period: this.$route.query.period ? this.$route.query.period : null,
        keyword: '',
        pindex: 1,
        type: null,
        psize: this.$store.state.commonStore.psize
      },
      total: 0,
      list: []
    }
  },
  computed: {
    billFlowTypeArr() {
      return this.$store.state.expenseStore.billFlowTypeArr
    },
  },
  created() {
    const keepAlivePath = [
    ]
    this.listQuery = this.$utils.initListQuery(this.listQuery, keepAlivePath)
    this.fetchData()
  },
  beforeRouteLeave(to, from, next) {
    this.$utils.saveListQuery(this.listQuery)
    next()
  },
  methods: {
    fetchData(page) {
      if (page) this.listQuery.pindex = page
      this.loading = true
      billFlowApi(this.listQuery).then(res => {
        this.loading = false
        if (!res.errno) {
          this.list = res.data.list
          this.total = res.data.total
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.expense-bill-statement {
  .bill-card {
    margin-bottom: 20px;
    border: 1px solid #ebeef5;
    .bill-body {
      padding: 20px;
      height: 90px;
      .content {
        height: 50px;
        display: inline-block;
        margin-left: 20px;
      }
      .flow {
        height: 50px;
      }
    }
  }
}
</style>
